import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { ApiClientConstant } from '@cureskin/api-client';
import { CsIconModule } from '@components/icon';
import { EventLoggerService } from '@services/event-logger-service';

/** Take-photo artwork for one gender. `mirrored` flips the source so both models face the same way. */
interface TakePhotoArt {
  src: string;
  mirrored: boolean;
}

@Component({
  selector: 'more-for-you',
  imports: [CsIconModule],
  templateUrl: './more-for-you.component.html',
})
export class MoreForYouComponent {
  readonly gender: InputSignal<string> = input<string>('');

  /** The two sources are mirror-composed, so only the female one is flipped to face the phone the same way. */
  private readonly takePhotoArtByGender: Record<string, TakePhotoArt> = {
    [ApiClientConstant.User.Gender.FEMALE]: {
      src: 'https://cdn.cureskin.com/app/img/rebranded_take_photo_banner.png',
      mirrored: true,
    },
    [ApiClientConstant.User.Gender.MALE]: {
      src: 'https://cdn.cureskin.com/app/img/male-face-ai-square.png',
      mirrored: false,
    },
  };

  /** Anything other than an explicit Male (unset, 'None', 'Both') falls back to the female artwork. */
  readonly takePhotoArt: Signal<TakePhotoArt> = computed((): TakePhotoArt => (
    this.gender() === ApiClientConstant.User.Gender.MALE
      ? this.takePhotoArtByGender[ApiClientConstant.User.Gender.MALE]
      : this.takePhotoArtByGender[ApiClientConstant.User.Gender.FEMALE]));

  router = inject(Router);
  private readonly eventLogger = inject(EventLoggerService);
  constructor() {}

  navigateToTakePhotoAnalysis(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'more_for_you_take_photo_analysis' }));
    this.router.navigate(['/user/instantCheckup']);
  }

  navigateToRefer(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'more_for_you_refer' }));
    this.router.navigate(['/user/refer']);
  }

  handleReportReactionClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'more_for_you_report_reaction' }));
    this.router.navigate(['/support']);
  }
}
